module.exports = __webpack_public_path__ + "static/media/Xiaomi Mi Mix Alpha Front.f24d288d.png";